import { Icon, IconButton, TextField, Tooltip } from '@material-ui/core';
import React, { Fragment } from 'react';

import FaqLink from './FaqLink';
import FacebookForm from '../FacebookForm';
import Platforms, { enTypePlatform } from '../Platforms';

interface IProps {
  conversionLabel: string;
  domain: string;
  hasDomain: boolean;
  tokenApi: string;
  loading: boolean;
  platformType: enTypePlatform;
  pixel: string;
  pixelId: string;
  validated: boolean;
  handleConversionLabel: (conversionLabel: string) => void;
  handlePixel: (pixel: string) => void;
  handleDelete: (idPixel: any, type: string) => Promise<void>;
  handleDomain: (domain: string) => void;
  handleTokenApi: (tokenApi: string) => void;
  handleReload: () => void;
  back: () => void;
}

function Basic({
  domain,
  validated,
  platformType,
  loading,
  conversionLabel,
  tokenApi,
  hasDomain,
  pixel,
  pixelId,
  handleConversionLabel,
  handleTokenApi,
  handleDelete,
  handlePixel,
  handleReload,
  handleDomain,
  back,
}: IProps) {
  const platform = (Platforms || []).find((x) => x.type === platformType);

  const imgUrl = platform?.image || '';
  const label = platform?.label || '';
  return (
    <Fragment>
      {platformType != null && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title='Voltar' placement='top'>
              <IconButton onClick={() => back()} style={{ marginRight: 8 }}>
                <Icon>arrow_back</Icon>
              </IconButton>
            </Tooltip>
            <img height={35} src={imgUrl} alt='platform' />
          </div>
          <div className='m24' />
          <div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <TextField value={pixel} label={label} onChange={(e: any) => handlePixel(e.target.value)} />
              {pixelId !== '' && (
                <Tooltip title='Deletar Pixel' placement='top'>
                  <IconButton style={{ marginLeft: 8 }} onClick={() => handleDelete(pixelId, platformType)}>
                    <Icon>delete</Icon>
                  </IconButton>
                </Tooltip>
              )}
            </div>
            {platformType !== enTypePlatform.FACEBOOK && <FaqLink link={platform.faqUrl} />}
            {platformType === enTypePlatform.FACEBOOK && (
              <FacebookForm
                handleReload={handleReload}
                loading={loading}
                tokenApi={tokenApi}
                handleTokenApi={handleTokenApi}
                hasDomain={hasDomain}
                validated={validated}
                handleDomain={handleDomain}
                domain={domain}
              />
            )}
            {platformType === enTypePlatform.ADWORDS && (
              <Fragment>
                <div className='m24' />
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <TextField value={conversionLabel} label='Label de conversão' onChange={(e: any) => handleConversionLabel(e.target.value)} />
                </div>
              </Fragment>
            )}
          </div>
          <div className='m16' />
        </div>
      )}
    </Fragment>
  );
}

export default Basic;
